import React, { forwardRef } from 'react';
import { CheckThick } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './checkbox.style';
import { Colors } from './types';

const predefinedColors = Object.values(Colors);

export type CheckboxProps = React.ComponentProps<'input'> & {
  color?: Colors | string;
  checkIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  keepColorOnChecked?: boolean;
  isSmall?: boolean;
  isPlaceholder?: boolean;
  isRecommended?: boolean;
  completionPercentage?: number;
  isFaded?: boolean;
};

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      children,
      color = Colors.Default,
      checkIcon = CheckThick,
      keepColorOnChecked,
      isSmall,
      isPlaceholder,
      isRecommended,
      completionPercentage,
      isFaded,
      disabled,
      ...rest
    },
    ref,
  ) => {
    return (
      <Styled.Container>
        <Styled.Input
          {...rest}
          ref={ref}
          disabled={disabled}
          type="checkbox"
          $color={color}
          $predefinedColors={
            predefinedColors.includes(color as Colors) ? undefined : color
          }
          $keepColorOnChecked={!!keepColorOnChecked}
          $isFaded={isFaded}
        />

        <Styled.Checkbox
          $color={color}
          $isPlaceholder={!!isPlaceholder}
          $isRecommended={!!isRecommended}
          $isDisabled={!!disabled}
          $completionPercentage={completionPercentage}
          $isSmall={!!isSmall}
          $isFaded={isFaded}
        >
          <Styled.Checkmark $isSmall={!!isSmall}>
            <Icon icon={checkIcon} />
          </Styled.Checkmark>
        </Styled.Checkbox>

        {!!children && <Styled.Label>{children}</Styled.Label>}
      </Styled.Container>
    );
  },
);
